import React from 'react';
import AccAuthPage from './parts/AccAuthPage';
import Navbar from '../components/Navbar';

function AccAuth() {
  <Navbar />
  return (
    
    <div className="App">
    <div className="container mt-3">
    <div className="row justify-content-center">
      <div className="col-md-12">
        <AccAuthPage />
        </div>
      </div>
    </div>
  </div>
  )
}

export default AccAuth